import { IFincen } from 'common/api/e-comm/cart';

export enum FincenFlowState {
    CAN_ORDER = 'CAN_ORDER',
    REQUIRES_INFORMATION_SUBMISSION = 'REQUIRES_INFORMATION_SUBMISSION',
    REQUIRES_INFORMATION_VERIFICATION = 'REQUIRES_INFORMATION_VERIFICATION',
    WILL_EDIT_CART = 'WILL_EDIT_CART',
}

export interface IFincenState {
    fincen: IFincen | null;
    fincenFlowState: FincenFlowState | null;
}

export interface IFincenFormUrl {
    updateFincenInfoUrl: string;
    enterFincenInfoUrl: string;
    moreInfoUrl: string;
}

export const defaultFincenFormUrl = {
    updateFincenInfoUrl: '',
    enterFincenInfoUrl: '',
    moreInfoUrl: '',
};
